import axios from './financeiroApi';

const getPath = () => `/api/v1/backend/produto`;

const getPathEstoque = () => `/api/v1/backend/estoque`;

const getParams = (params) => {
  let newParams;
  if (params?.filtroAvancado) {
    if (params.filtroAvancado.nome) {
      newParams = { ...params, ...params.filtroAvancado, nome: params.filtroAvancado.nome.nome };
    } else {
      newParams = { ...params, ...params.filtroAvancado };
    }

    delete newParams.filtroAvancado;
  } else {
    newParams = params;
  }
  return newParams;
};

const produtoApi = {
  get: (search) => {
    const url = `${getPath()}`;
    return axios.get(url, { params: getParams(search) });
  },
  buscarProdutosEstoque: (search) => {
    const url = `${getPathEstoque()}?page=${search.page}&size=${search.size}${search.q ? `&q=${search.q}` : ''}${
      search.sort ? `&sort=${search.sort}` : ''
    }`;

    return axios.get(url);
    // return produtos;
  },
  buscarInventario: (query) => {
    const url = `${getPathEstoque()}?${query}`;

    return axios.get(url);
  },
  buscarHistoricoEstoque: (produtoId, search) => {
    const url = `${getPathEstoque()}/${produtoId}`;

    return axios.get(url, { params: getParams(search) });
  },

  cadastrarInventario: (inventarios) => {
    const url = `${getPathEstoque()}`;

    return axios.post(url, inventarios);
  },
  getOne: (produtoId) => {
    const url = `${getPath()}/${produtoId}`;
    return axios.get(url);
  },
  post: (produto) => {
    const url = `${getPath()}`;
    return axios.post(url, produto);
  },
  put: (produto) => {
    const url = `${getPath()}/${produto.id}`;
    return axios.put(url, produto);
  },
  delete: (filtro) => {
    return axios.delete(getPath(), { params: filtro });
  },
  inactive: (filtro) => {
    const url = `${getPath()}/inativar`;
    return axios.patch(url, filtro);
  },
  active: (filtro) => {
    const url = `${getPath()}/ativar`;
    return axios.patch(url, filtro);
  },
  uploadImage: (formData) => {
    const url = `/api/v1/backend/produto/imagem/upload`;
    return axios.put(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        type: 'formData',
      },
    });
  },
  pesquisar: (params) => {
    const url = `/api/v1/backend/produto/pesquisar`;
    return axios.get(`${url}`, { params });
  },
  getImagemUrl: (path) => {
    return `${process.env.REACT_APP_BASE_URL}/${path}`;
  },
};

export { produtoApi };
